import { AssociationAccountTypeEnum } from 'src/shared/models/enums/associationAccountType.enum';

// Fakturablankett-val (inv_template.formTemplate). Vilka val som är tillåtna styrs av faktureringsgruppens kontotyp:
// Bankgiro-grupp får bara Bankgiro OCR, Plusgiro-grupp bara Plusgiro OCR. "Inget inbetalningskort" (blank) är alltid tillåtet.
export interface BlankettOption {
  code: string;
  label: string;
  description: string;
}

export const BLANK_OPTION: BlankettOption = {
  code: 'blank',
  label: 'Inget inbetalningskort',
  description: 'Fakturan skrivs ut utan avi – betalning sker via gruppens aktiva betalsätt.',
};

// Används av utskicks-wizarden.
export const accountTypeToBlankettOptions = (accountType: number | null): BlankettOption[] => {
  const opts: BlankettOption[] = [];
  // Bankgiro använder den nya blanketten "Bankgiro OCR 2024" (bgocr_2024), inte den gamla bgocr.
  if (accountType === AssociationAccountTypeEnum.Bankgiro)
    opts.push({ code: 'bgocr_2024', label: 'Bankgiro OCR', description: 'Inbetalningskort med OCR-referens, kopplat till Bankgiro.' });
  else if (accountType === AssociationAccountTypeEnum.Plusgiro)
    opts.push({ code: 'pgocr', label: 'Plusgiro OCR', description: 'Inbetalningskort med OCR-referens, kopplat till Plusgiro.' });
  opts.push(BLANK_OPTION);
  return opts;
};

// Samtliga blanketter, oavsett kontotyp. Används i fakturamallsmodalen (AdminInvoiceTemplateDetail).
export const allBlankettOptions: BlankettOption[] = [
  BLANK_OPTION,
  { code: 'bgocr', label: 'Bankgiro OCR', description: '' },
  { code: 'bg42', label: 'Bankgiro OCR flexibelt belopp', description: '' },
  { code: 'card', label: 'Medlemskort', description: '' },
  { code: 'bgman', label: 'Bankgiro manuell', description: '' },
  { code: 'pgman', label: 'Plusgiro manuell', description: '' },
  { code: 'agavi', label: 'Autogiro', description: '' },
  { code: 'bgcard', label: 'Bankgiro och kort', description: '' },
  { code: 'pgocr', label: 'Plusgiro OCR', description: '' },
  { code: 'bgocr_2024', label: 'Bankgiro OCR 2024', description: '' },
  { code: 'qrcode', label: 'QR-kod', description: '' },
];
